var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1044 1.80245C11.4721 1.06239 12.5279 1.06239 12.8956 1.80245L15.3084 6.65871C15.454 6.95177 15.7338 7.15505 16.0575 7.20297L21.4217 7.99706C22.2392 8.11807 22.5654 9.12211 21.9752 9.7005L18.1022 13.4959C17.8685 13.725 17.7616 14.0539 17.8161 14.3766L18.7185 19.7236C18.856 20.5384 18.0019 21.159 17.2695 20.7764L12.463 18.2658C12.1729 18.1143 11.8271 18.1143 11.537 18.2658L6.73055 20.7764C5.99808 21.159 5.14399 20.5384 5.28151 19.7236L6.18391 14.3766C6.23837 14.0539 6.1315 13.725 5.89778 13.4959L2.02481 9.7005C1.4346 9.12211 1.76083 8.11808 2.57829 7.99706L7.94248 7.20297C8.2662 7.15505 8.54599 6.95177 8.6916 6.65871L11.1044 1.80245Z",
    fill: "#F1C83A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_970_482",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1044 1.80245C11.4721 1.06239 12.5279 1.06239 12.8956 1.80245L15.3084 6.65871C15.454 6.95177 15.7338 7.15505 16.0575 7.20297L21.4217 7.99706C22.2392 8.11807 22.5654 9.12211 21.9752 9.7005L18.1022 13.4959C17.8685 13.725 17.7616 14.0539 17.8161 14.3766L18.7185 19.7236C18.856 20.5384 18.0019 21.159 17.2695 20.7764L12.463 18.2658C12.1729 18.1143 11.8271 18.1143 11.537 18.2658L6.73055 20.7764C5.99808 21.159 5.14399 20.5384 5.28151 19.7236L6.18391 14.3766C6.23837 14.0539 6.1315 13.725 5.89778 13.4959L2.02481 9.7005C1.4346 9.12211 1.76083 8.11808 2.57829 7.99706L7.94248 7.20297C8.2662 7.15505 8.54599 6.95177 8.6916 6.65871L11.1044 1.80245Z",
    fill: "#F1C83A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_970_482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.5C9.3 10.1 11.1667 3 12.5 0.5L1 7L0.5 15L6 25.5C9.3331 26.6667 15.7 26.9 12.5 18.5Z",
    fill: "#EDB017"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatured);
export default __webpack_public_path__ + "static/media/featured.4a854d2da8d0470da015e958368d608b.svg";
export { ForwardRef as ReactComponent };